import React from "react";

export interface SvgIconButtonProps {
  /** Full SVG string from @resmed/lumina-design-system-assets/dist/icons */
  icon: string;
  ariaLabel: string;
  size?: number;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLSpanElement>;
  "data-testid"?: string;
}

/**
 * Renders an LDS icon (full SVG string) inline with controlled dimensions.
 * Overrides the SVG's em-based width/height with pixel values and removes
 * aria-hidden so the icon is accessible as a button.
 */
const SvgIconButton = ({
  icon,
  ariaLabel,
  size = 16,
  className = "",
  onClick,
  "data-testid": testId,
}: SvgIconButtonProps) => {
  const normalised = icon
    .replace(/width="[^"]*"/, `width="${size}"`)
    .replace(/height="[^"]*"/, `height="${size}"`)
    .replace(/aria-hidden="true"/, 'aria-hidden="false"');

  return (
    <span
      role="button"
      aria-label={ariaLabel}
      data-testid={testId}
      className={`lds-cursor-pointer lds-inline-flex lds-items-center lds-justify-center lds-opacity-60 hover:lds-opacity-100 lds-transition-opacity ${className}`}
      style={{ width: size, height: size }}
      onClick={onClick}
      dangerouslySetInnerHTML={{ __html: normalised }}
    />
  );
};

export default SvgIconButton;

